import { IPublishOptions } from '../../../../../redux/reducers';
import { IPublishOptionsSchema } from '../../internalTypes';
import { getOptionId } from '../getOptionId';
import { mapPackages } from './mapPackages';
import { mapPeriods } from './mapPeriods';
import { mapRecommendedPackages } from './mapRecommendedPackages';
import { getSelectedPackageId } from './getSelectedPackageId';
import { getSelectedPeriodId } from './getSelectedPeriodId';
import { getSelectedPlacingType } from './getSelectedPlacingType';
import { getSelectedRecommendedPackageId } from './getSelectedRecommendedPackageId';

export function mapPublishOptions(publishOptions?: IPublishOptionsSchema | null): IPublishOptions {
  const rawPeriods = publishOptions?.periods || [];
  const rawPackages = publishOptions?.servicePackages || [];
  const rawRecommendedPackages = publishOptions?.recommendedServicePackages || [];

  const periodIds = rawPeriods.map(getOptionId);
  const periods = mapPeriods(rawPeriods);
  const selectedPeriodId = getSelectedPeriodId(rawPeriods);

  const packageIds = rawPackages.map(getOptionId);
  const packages = mapPackages(rawPackages);
  const selectedPackageId = getSelectedPackageId(rawPackages);

  const recommendedPackageIds = rawRecommendedPackages.map(({ id }) => id);
  const recommendedPackages = mapRecommendedPackages(rawRecommendedPackages);
  const selectedRecommendedPackageId = getSelectedRecommendedPackageId(rawRecommendedPackages);

  const selectedPlacingType = getSelectedPlacingType(rawPeriods, rawPackages);

  return {
    periods,
    periodIds,
    selectedPeriodId,
    packages,
    packageIds,
    selectedPackageId,
    recommendedPackages,
    recommendedPackageIds,
    selectedRecommendedPackageId,
    selectedPlacingType,
  };
}
